export default __webpack_public_path__ + "static/media/more-info-alt.caf018ff.svg";